"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = require("../../../../../shared/services");
var initialState = function () {
    return {
        shippingMethod: services_1.appSessionStorage.getItem('checkout-shipping-method', {}),
        shippingMethods: [],
        loadingShippingMethods: true
    };
};
var getters = {
    getShippingMethods: function (state) { return state.shippingMethods; },
};
var mutations = {
    SET_LOADING_SHIPPING_METHODS: function (state, status) {
        state.loadingShippingMethods = status;
    },
    SET_SHIPPING_METHOD: function (state, shippingMethod) {
        services_1.appSessionStorage.setItem('checkout-shipping-method', shippingMethod);
        state.shippingMethod = shippingMethod;
    },
    SET_SHIPPING_METHODS: function (state, shippingMethods) {
        state.shippingMethods = shippingMethods;
    }
};
var actions = {
    /* Step 2 */
    setShippingMethod: function (_a, shippingMethod) {
        var commit = _a.commit;
        commit('SET_SHIPPING_METHOD', shippingMethod);
    },
    collectShippingMethods: function (_a) {
        var rootState = _a.rootState, rootGetters = _a.rootGetters, commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var data, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit('SET_LOADING_SHIPPING_METHODS', true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, 7, 8]);
                        return [4 /*yield*/, this.$mageClient.get(rootGetters['CheckoutGlobal/getApiPathWithQuoteMask'] + "/shipping-methods")];
                    case 2:
                        data = (_b.sent()).data;
                        if (!(data.length === 1)) return [3 /*break*/, 4];
                        return [4 /*yield*/, commit('SET_SHIPPING_METHOD', data[0])];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [4 /*yield*/, commit('SET_SHIPPING_METHODS', data)];
                    case 5:
                        _b.sent();
                        return [3 /*break*/, 8];
                    case 6:
                        e_1 = _b.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        commit('SET_LOADING_SHIPPING_METHODS', false);
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
};
var state = initialState();
var CheckoutShipping = {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};
exports.default = CheckoutShipping;
